import React, {useEffect, useState} from "react";
import {
    ContainerNews,
    CalendarPageHeader,
    CalendarStack,
    CalendarPageInner,
    CalendarCardColumn,
    CalendarTabsArea,
    CalendarLegendList,
    CalendarLegendItem,
    CalendarInfoNote,
} from "./styles";
import BullOne from "../../assets/img/bull-one.png";
import BullTwo from "../../assets/img/bull-two.png";
import BullThree from "../../assets/img/bull-three.png";
import {useSelector} from "react-redux";
import Events from "../../components/Events";
import FundamentalTrading from "../../components/FundamentalTrading";
import EventReport from "../../components/Report/EventReport";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../components/DivDiagonal";
import {TradingWrapper, ContentArea} from "../Trading/styles";
import {StrategyProductCard} from "../Strategy/styles";
import InvestingCalendarEmbed from "./InvestingCalendarEmbed";

const INVESTING_CALENDAR_SRC =
    'https://sslecal2.investing.com?ecoDayBackground=%23b3b3b3&columns=exc_flags,exc_currency,exc_importance,exc_actual,exc_forecast,exc_previous&features=datepicker,timezone&countries=110,17,29,25,32,6,37,36,26,5,22,39,14,48,10,35,7,43,38,4,12,72&calType=day&timeZone=12&lang=12';

export default function EconomicCalendar() {
    const [deleteItem, setDeleteItem] = useState(null);
    const { t } = useTranslation();
    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const showExtendedTabs = [
        'teste@teste.com',
    ].includes(localStorage.getItem('userKey'));

    return (
        <>
            {isActiveSignature && (
                <TradingWrapper>
                    <DivDiagonal/>
                    <ContentArea>
                        <CalendarPageInner>
                            <CalendarStack>
                                <CalendarPageHeader>
                                    <h1>
                                        <i className="fa fa-calendar-day" aria-hidden="true"/>
                                        {' '}{t('calendar_title')}
                                    </h1>
                                </CalendarPageHeader>

                                <CalendarCardColumn>
                                    <StrategyProductCard>
                                        <CalendarTabsArea>
                                            {showExtendedTabs && (
                                                <ul
                                                    className="nav nav-tabs nav-tabs-calendar"
                                                    id="economicCalendarTab"
                                                    role="tablist"
                                                >
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link active"
                                                            id="calendar-notice-tab"
                                                            data-toggle="tab"
                                                            href="#calendar"
                                                            role="tab"
                                                            aria-controls="calendar"
                                                            aria-selected="true"
                                                        >
                                                            {t('calendar_tab_1')}
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            id="report-events-tab"
                                                            data-toggle="tab"
                                                            href="#report-events"
                                                            role="tab"
                                                            aria-controls="report-events"
                                                            aria-selected="false"
                                                        >
                                                            {t('calendar_tab_2')}
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            id="fundamentalista-tab"
                                                            data-toggle="tab"
                                                            href="#fundamentalista"
                                                            role="tab"
                                                            aria-controls="fundamentalista"
                                                            aria-selected="false"
                                                        >
                                                            {t('calendar_tab_3')}
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a
                                                            className="nav-link"
                                                            id="events-tab"
                                                            data-toggle="tab"
                                                            href="#events"
                                                            role="tab"
                                                            aria-controls="events"
                                                            aria-selected="false"
                                                        >
                                                            {t('calendar_tab_4')}
                                                        </a>
                                                    </li>
                                                </ul>
                                            )}
                                            <div className="tab-content" id="economicCalendarTabContent">
                                                <div
                                                    className="tab-pane fade show active"
                                                    id="calendar"
                                                    role="tabpanel"
                                                    aria-labelledby="calendar-notice-tab"
                                                >
                                                    <ContainerNews>
                                                        <CalendarLegendList>
                                                            <CalendarLegendItem>
                                                                <img src={BullOne} alt="" style={{marginLeft: '-8px'}}/>
                                                                <div>
                                                                    <label className="mb-0 d-block">
                                                                        <b>{t('calendar_volatility_1')}</b>
                                                                    </label>
                                                                    <small>{t('calendar_volatility_1_resume')}</small>
                                                                </div>
                                                            </CalendarLegendItem>
                                                            <CalendarLegendItem>
                                                                <img src={BullTwo} alt="" style={{marginLeft: '-5px'}}/>
                                                                <div>
                                                                    <label className="mb-0 d-block">
                                                                        <b>{t('calendar_volatility_2')}</b>
                                                                    </label>
                                                                    <small>{t('calendar_volatility_2_resume')}</small>
                                                                </div>
                                                            </CalendarLegendItem>
                                                            <CalendarLegendItem>
                                                                <img src={BullThree} alt="" className="pr-1"/>
                                                                <div>
                                                                    <label className="mb-0 d-block">
                                                                        <b>{t('calendar_volatility_3')}</b>
                                                                    </label>
                                                                    <small>{t('calendar_volatility_3_resume')}</small>
                                                                </div>
                                                            </CalendarLegendItem>
                                                        </CalendarLegendList>

                                                        <CalendarInfoNote>
                                                            <i className="fa fa-info-circle" aria-hidden="true"/>
                                                            {t('calendar_alert_usd')}
                                                        </CalendarInfoNote>

                                                        <InvestingCalendarEmbed
                                                            id="iframe-calendar"
                                                            title={t('calendar_title')}
                                                            src={INVESTING_CALENDAR_SRC}
                                                        />
                                                        <div className="poweredBy">
                                                            <span>
                                                                {t('calendar_credits_par_1')}
                                                                <a
                                                                    href="https://br.investing.com/"
                                                                    rel="nofollow noopener noreferrer"
                                                                    target="_blank"
                                                                    className="underline_link"
                                                                >
                                                                    Investing.com Brasil
                                                                </a>
                                                                {', '}{t('calendar_credits_par_2')}
                                                            </span>
                                                        </div>
                                                    </ContainerNews>
                                                </div>
                                                <div
                                                    className="tab-pane fade pt-2"
                                                    id="report-events"
                                                    role="tabpanel"
                                                    aria-labelledby="report-events-tab"
                                                >
                                                    <EventReport deleteItem={deleteItem}/>
                                                </div>
                                                <div
                                                    className="tab-pane fade pt-2"
                                                    id="fundamentalista"
                                                    role="tabpanel"
                                                    aria-labelledby="fundamentalista-tab"
                                                >
                                                    <FundamentalTrading deleteItem={deleteItem} setDeleteItem={setDeleteItem}/>
                                                </div>
                                                <div
                                                    className="tab-pane fade pt-2"
                                                    id="events"
                                                    role="tabpanel"
                                                    aria-labelledby="events-tab"
                                                >
                                                    <Events/>
                                                </div>
                                            </div>
                                        </CalendarTabsArea>
                                    </StrategyProductCard>
                                </CalendarCardColumn>
                            </CalendarStack>
                        </CalendarPageInner>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    );
}
